<template>
  <v-container class="provider-details-page" fluid>
    <!-- Header -->
    <v-row class="mb-5">
      <v-col cols="12">
        <div class="d-flex align-center">
          <v-avatar size="48" color="primary" class="mr-3">
            <v-icon size="28" color="white">mdi-stethoscope</v-icon>
          </v-avatar>
          <div>
            <h1 class="display-1 mb-1 font-weight-bold">Provider Details</h1>
            <p class="subtitle-1 grey--text text--darken-1 mb-0">
              Your profile, credentials, and rate information
            </p>
          </div>
        </div>
      </v-col>
    </v-row>

    <!-- Empty state -->
    <v-card v-if="!user || !user.npi" elevation="2" class="rounded-xl">
      <v-card-text class="pa-10 text-center">
        <v-icon size="72" color="grey lighten-1" class="mb-4">mdi-account-alert-outline</v-icon>
        <h2 class="headline mb-2">Provider NPI not found</h2>
        <p class="body-1 grey--text mb-0">
          Please contact support to associate your NPI with your account.
        </p>
      </v-card-text>
    </v-card>

    <!-- Content -->
    <div v-else class="provider-details-wrapper">
      <ProviderDetailsFHC
        :provider="myProvider"
        content-only
        page-mode
        :hide-rates="false"
        :hide-close-button="true"
      />
    </div>
  </v-container>
</template>

<script>
import axios from 'axios';
import ProviderDetailsFHC from '../components/ProviderDetailsFHC.vue';

export default {
  name: 'ProviderDetailsPage',
  components: {
    ProviderDetailsFHC,
  },
  data() {
    return {
      user: null,
    };
  },
  computed: {
    myProvider() {
      if (!this.user || !this.user.npi) return {};
      const npi = String(this.user.npi);
      return {
        PROVIDER_ID: npi,
        provider_id: npi,
        NPI: npi,
      };
    },
  },
  mounted() {
    this.getUser();
  },
  methods: {
    async getUser() {
      try {
        const response = await axios.get('/api/user');
        const data = response.data;
        this.user = Array.isArray(data) ? data[0] : data;
        if (!this.user || typeof this.user !== 'object') {
          this.$router.push('/login');
        }
      } catch (e) {
        this.$router.push('/login');
      }
    },
  },
};
</script>

<style scoped>
.provider-details-page {
  padding: 24px;
  max-width: 960px;
  margin: 0 auto;
}

.provider-details-wrapper >>> .v-card {
  border-radius: 12px;
}
</style>
